module.exports = __webpack_public_path__ + "img/map_all-you-can-eat.ada7003f.jpg";